import { render, staticRenderFns } from "./Work.vue?vue&type=template&id=81274620&scoped=true&"
import script from "./Work.vue?vue&type=script&lang=ts&"
export * from "./Work.vue?vue&type=script&lang=ts&"
import style0 from "./Work.vue?vue&type=style&index=0&id=81274620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81274620",
  null
  
)

export default component.exports